
import { defineComponent, ref, onMounted, computed } from "vue"
import { Actions } from "@/store/enums/StoreEnums"
import { useStore } from "vuex"
import { useRoute, useRouter } from "vue-router"
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb"
import { ElMessage } from "element-plus"
import { MallOrder } from "@/store/modules/MallOrderModule"

export default defineComponent({
  components: {},
  setup() {
    const store = useStore()
    const route = useRoute()
    const router = useRouter()
    const order = ref({} as MallOrder)
    const shipping = ref(false)

    const shipForm = ref({
      shipping_company: '',
      tracking_no: ''
    })

    onMounted(() => {
      setCurrentPageBreadcrumbs("订单详情", ["商城订单管理;mall_orders", route.params.id as string])
      loadOrder()
    })

    const loadOrder = () => {
      store
        .dispatch(Actions.GET_MALL_ORDER, route.params.id)
        .then(() => {
          order.value = store.getters.currentMallOrder
        })
        .catch(() => {
          ElMessage.error('获取订单详情失败')
        })
    }

    const remainingAmount = computed(() => {
      if (!order.value.total_amount || !order.value.paid_amount) return '0.00'
      const remaining = parseFloat(order.value.total_amount) - parseFloat(order.value.paid_amount)
      return remaining > 0 ? remaining.toFixed(2) : '0.00'
    })

    const paidPayments = computed(() => {
      if (!order.value.payments) return []
      return order.value.payments.filter((p: any) => p.status === 'paid')
    })

    const getStatusType = (status: string) => {
      const statusMap: Record<string, string> = {
        pending_payment: 'warning',
        deposit_paid: 'info',
        pending_shipment: 'primary',
        shipped: '',
        completed: 'success',
        cancelled: 'info',
        refunded: 'danger'
      }
      return statusMap[status] || ''
    }

    const onShip = () => {
      if (!shipForm.value.shipping_company) {
        ElMessage.warning('请选择物流公司')
        return
      }
      if (!shipForm.value.tracking_no) {
        ElMessage.warning('请输入物流单号')
        return
      }

      shipping.value = true
      store
        .dispatch(Actions.SHIP_MALL_ORDER, {
          id: route.params.id,
          ...shipForm.value
        })
        .then(() => {
          ElMessage.success('发货成功')
          loadOrder()
        })
        .catch(() => {
          ElMessage.error('发货失败')
        })
        .finally(() => {
          shipping.value = false
        })
    }

    const onBack = () => {
      router.push({ name: 'mall_orders' })
    }

    const formatPrice = (price: number | string | null | undefined): string => {
      if (price === null || price === undefined) return '0.0'
      const num = Number(price)
      return isNaN(num) ? '0.0' : num.toFixed(1)
    }

    return {
      order,
      shipForm,
      shipping,
      remainingAmount,
      paidPayments,
      getStatusType,
      onShip,
      onBack,
      formatPrice
    }
  },
})
